export enum SaleRuleAtrribute {
  BASE_TOTAL = 'base_total',
  DISTANCE = 'distance',
  PAYMENT_METHOD = 'payment_method',
  SHIPPING_FEE = 'shipping_fee',
}
